import { venueText, type PublicEvent } from './publicEvent'

type CalendarEvent = Pick<PublicEvent, 'name' | 'url' | 'starts_at' | 'ends_at' | 'time_zone' | 'online' | 'venue'>

export type CalendarButtonEvent = {
  name: string
  startDate: string
  startTime: string
  endDate: string
  endTime: string
  timeZone: string
  location?: string
  description?: string
  iCalFileName: string
}

const HOUR = 60 * 60 * 1000

export function calendarButtonEvent(event: CalendarEvent): CalendarButtonEvent | null {
  if (!event.starts_at) return null

  const start = new Date(event.starts_at)
  const end = event.ends_at ? new Date(event.ends_at) : new Date(start.getTime() + HOUR)
  const [startDate, startTime] = inZone(start, event.time_zone)
  const [endDate, endTime] = inZone(end, event.time_zone)

  return {
    name: event.name,
    startDate,
    startTime,
    endDate,
    endTime,
    timeZone: event.time_zone,
    location: (event.online ? event.url : venueText(event.venue)) || undefined,
    description: event.url ?? undefined,
    iCalFileName: event.name,
  }
}

function inZone(date: Date, timeZone: string) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(date)
      .map(({ type, value }) => [type, value])
  )

  return [`${parts.year}-${parts.month}-${parts.day}`, `${parts.hour}:${parts.minute}`] as const
}
